export default __webpack_public_path__ + "static/media/gu.7a902847.svg";